import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

interface Experience {
  id: number;
  title: string;
  challenge: string;
  solution: string | null;
  questions: string | null;
  user_name: string;
  product_type: string;
  status: string;
  views: number;
  created_at: string;
}

const ExperienceDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [experience, setExperience] = useState<Experience | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    
    fetch(`https://fellfell.ir/api/experiences.php?action=single&id=${id}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        console.log('📦 پاسخ تجربه:', data);
        if (data.success && data.data) {
          setExperience(data.data);
        } else {
          setError(data.message || 'تجربه یافت نشد');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('❌ خطا:', err);
        setError('خطا در بارگذاری تجربه');
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        ⏳ در حال بارگذاری تجربه...
      </div>
    );
  }

  if (error || !experience) {
    return (
      <div style={{ padding: '20px', color: '#c62828', background: '#ffebee', borderRadius: '10px' }}>
        ❌ {error || 'تجربه یافت نشد'}
      </div>
    );
  }

  return (
    <>
      <div style={{ background: '#1e3a1e', color: '#fff', padding: '40px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <h1 style={{ fontSize: '28px' }}>🌾 {experience.title}</h1>
        </div>
      </div>
      
      <section style={{ padding: '30px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ 
            background: '#fff', 
            borderRadius: '16px', 
            padding: '30px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
              <div>
                <span style={{ padding: '5px 15px', background: '#e8f5e9', color: '#2e7d32', borderRadius: '20px', fontSize: '13px' }}>
                  🌱 {experience.product_type || 'متفرقه'}
                </span>
              </div>
              <div style={{ color: '#888', fontSize: '14px' }}>
                👤 {experience.user_name || 'کشاورز'} | 
                📅 {new Date(experience.created_at).toLocaleDateString('fa-IR')} |
                👁️ {experience.views || 0} بازدید
              </div>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ color: '#1e3a1e', fontSize: '18px', marginBottom: '10px' }}>💡 چالش</h3>
              <p style={{ lineHeight: '1.9', fontSize: '15px', color: '#333' }}>
                {experience.challenge}
              </p>
            </div>

            {experience.questions && (
              <div style={{ marginBottom: '25px', background: '#fff3e0', padding: '15px 20px', borderRadius: '10px', borderRight: '4px solid #f57c00' }}>
                <h3 style={{ color: '#e65100', fontSize: '16px', marginBottom: '8px' }}>❓ سوالات</h3>
                <p style={{ lineHeight: '1.9', fontSize: '15px', color: '#333' }}>
                  {experience.questions}
                </p>
              </div>
            )}

            {experience.solution && (
              <div style={{ marginBottom: '25px', background: '#e8f5e9', padding: '15px 20px', borderRadius: '10px', borderRight: '4px solid #2e7d32' }}>
                <h3 style={{ color: '#1b5e20', fontSize: '16px', marginBottom: '8px' }}>✅ راه‌حل</h3>
                <p style={{ lineHeight: '1.9', fontSize: '15px', color: '#333' }}>
                  {experience.solution}
                </p>
              </div>
            )}

            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
              <Link to="/experiences" style={{ color: '#2e7d32', textDecoration: 'none' }}>
                ← بازگشت به لیست تجارب
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExperienceDetail;